<template>
  <div class="CampaignInfoMain">
    <div class="typed-on-paper">
      <CampaignInfoBaseComp v-bind="campaign"></CampaignInfoBaseComp>
    </div>
    <router-view name="subcontent"></router-view>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import CampaignInfoBaseComp from "./CampaignInfoBaseComp";
import CampaignInfoHelp from "./CampaignInfoHelp";

export default {
  name: 'CampaignInfoMain',
  components: {CampaignInfoBaseComp, CampaignInfoHelp},
  mounted () {

    this.$store.dispatch('missionStore/loadStoreData',
      {
        caller: this.$options.name,
        call_object: {
          view: "campaign_list",
          id: this.$route.params.campaign_id
        },
        data_array_name: "campaign"
      }
    ).catch(error => {
      console.log(error.message);
    });
  },
  computed: {

    ...mapState("missionStore", {

      campaign: state => state.campaign,
    }),
  },
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/campaign/CampaignInfoMain.vue